<template>
  <div>
    <h4>
      {{ $t('deliveryAddress.changeInfo') }}
    </h4>
    <br>
    <form-error :errors='errors' :attribute="'address_line_1'">
      <input v-model="deliveryAddress.address_line_1" class="form-control" :placeholder="$t('profile.edit.streetName')">
    </form-error>
    <form-error :errors='errors' :attribute="'address_line_2'">
      <input v-model="deliveryAddress.address_line_2" class="form-control" :placeholder="$t('profile.edit.streetNumber')">
    </form-error>
    <form-error :errors='errors' :attribute="'zip_code'">
      <input v-model="deliveryAddress.zip_code" class="form-control" :placeholder="$t('profile.edit.zipCode')">
    </form-error>
    <form-error :errors='errors' :attribute="'city'">
      <input v-model="deliveryAddress.city" class="form-control" :placeholder="$t('city')">
    </form-error>
    <form-error :errors='errors' :attribute="'country'">
      <select v-if="countries.length" v-model="deliveryAddress.country_id" class="form-control">
        <option disabled value="">{{ $t('country') }}</option>
        <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
      </select>
    </form-error>
    <button @click="saveDeliveryAddress"
      type="button"
      class="btn btn-default btn-lg button-wide-crowd">
      <span v-if="!processing">{{ $t(`deliveryAddress.${deliveryAddress.id ? "changeAddress" : "saveAddress"}`) }}</span>
      <clip-loader :loading="processing" :color="'#fff'" size="18px"></clip-loader>
    </button>
    <alert :success="alert.success"></alert>
  </div>
</template>

<script>
// API
import deliveryApi from '@/api/v1/delivery_addresses';
// Components
import FormError from '@/components/FormError';
import ClipLoader from 'vue-spinner/src/ClipLoader';
import Alert from '@/components/Alert';
// Mixins
import alert from '@/mixins/alert';

export default {
  components: { FormError, ClipLoader, Alert },
  props: {
    countries: Array,
  },
  mixins: [alert],
  data() {
    return {
      processing: false,
      deliveryAddress: {
        country_id: '',
      },
    };
  },
  methods: {
    saveDeliveryAddress() {
      this.processing = true;
      this.clearAlerts();
      const promise =
        this.deliveryAddress.id ? deliveryApi.update(this.deliveryAddress) : deliveryApi.create(this.deliveryAddress);

      promise.then((response) => {
        this.processing = false;
        this.alert.success = this.$t('deliveryAddress.changesSaved');
        this.deliveryAddress = response.data;
        this.$emit('onChange', this.deliveryAddress);
      }).catch((err) => {
        this.processing = false;
        this.errors = err.response.data;
      });
    },
  },
  created() {
    deliveryApi.index((deliveryAddress) => {
      if (!deliveryAddress.country_id) deliveryAddress.country_id = '';
      this.deliveryAddress = deliveryAddress;
      this.$emit('onChange', deliveryAddress);
    });
  },
};
</script>



// WEBPACK FOOTER //
// DeliveryAddress.vue?15c29414